import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import React from 'react';
export interface OrbitingCircleProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  children?: React.ReactNode;
  reverse?: boolean;
  duration?: number;
  delay?: number;
  radius?: number;
  radiusClassName?: string;
  path?: boolean;
  iconSize?: number;
  speed?: number;
}
function OrbitingCircle(t0) {
  const $ = _c(30);
  let children;
  let className;
  let props;
  let radiusClassName;
  let reverse;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== t0) {
    ({
      className,
      children,
      reverse,
      duration: t1,
      radius: t2,
      radiusClassName,
      path: t3,
      iconSize: t4,
      speed: t5,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = radiusClassName;
    $[5] = reverse;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    radiusClassName = $[4];
    reverse = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
  }
  const duration = t1 === undefined ? 20 : t1;
  const radius = t2 === undefined ? 160 : t2;
  const path = t3 === undefined ? true : t3;
  const iconSize = t4 === undefined ? 30 : t4;
  const speed = t5 === undefined ? 1 : t5;
  const calculatedDuration = duration / speed;
  let t6;
  if ($[11] !== radius || $[12] !== radiusClassName) {
    t6 = radiusClassName ? {} : {
      "--radius": radius
    } as React.CSSProperties;
    $[11] = radius;
    $[12] = radiusClassName;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const radiusStyle = t6;
  let t7;
  if ($[14] !== path || $[15] !== radiusClassName || $[16] !== radiusStyle) {
    t7 = path && <svg xmlns="http://www.w3.org/2000/svg" version="1.1" className={cn("pointer-events-none absolute inset-0 size-full", radiusClassName)} style={radiusStyle}><circle className="stroke-black/10 stroke-1 dark:stroke-white/10" cx="50%" cy="50%" fill="none" style={{
        r: "calc(var(--radius) * 1px)"
      } as React.CSSProperties} /></svg>;
    $[14] = path;
    $[15] = radiusClassName;
    $[16] = radiusStyle;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== calculatedDuration || $[19] !== children || $[20] !== className || $[21] !== iconSize || $[22] !== props || $[23] !== radiusClassName || $[24] !== radiusStyle || $[25] !== reverse) {
    t8 = React.Children.map(children, (child, index) => {
      const angle = 360 / React.Children.count(children) * index;
      return <div style={{
        "--duration": calculatedDuration,
        "--angle": angle,
        "--icon-size": `${iconSize}px`,
        ...radiusStyle
      } as React.CSSProperties} className={cn("animate-orbit absolute flex size-(--icon-size) transform-gpu items-center justify-center rounded-full", {
        "[animation-direction:reverse]": reverse
      }, radiusClassName, className)} {...props}>{child}</div>;
    });
    $[18] = calculatedDuration;
    $[19] = children;
    $[20] = className;
    $[21] = iconSize;
    $[22] = props;
    $[23] = radiusClassName;
    $[24] = radiusStyle;
    $[25] = reverse;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== t7 || $[28] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[27] = t7;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  return t9;
}
export { OrbitingCircle };